module.exports = __webpack_public_path__ + "media/icons/brand/reduced-bad27787b5826e15ab2fedcf53ca233b.svg";